import React from "react";
import { FormattedMessage } from "react-intl";
import { OnfidoDocumentFailedType } from "./OnfidoDocumentFailedType";
import { OnfidoConsider } from "./OnfidoConsider";
import { OnfidoPending } from "./OnfidoPending";
import { OnfidoPendingManualReview } from "./OnfidoPendingManualReview";
import { LysaManualReview } from "./LysaManualReview";
import { Clear } from "./Clear";
import { LysaManualReviewRejected } from "./LysaManualReviewRejected";
import { OnfidoCanceled } from "./OnfidoCanceled";
import { OnfidoFailedUserError } from "./OnfidoFailedUserError";
import { OnfidoFailedStarted } from "./OnfidoFailedStarted";
export const IdStatus = ({ idStatus }) => {
    if (!idStatus) {
        return React.createElement(FormattedMessage, { id: "onfido.status.id.not_started" });
    }
    const status = {
        ONFIDO_PENDING: React.createElement(OnfidoPending, null),
        ONFIDO_PENDING_MANUAL_REVIEW: React.createElement(OnfidoPendingManualReview, null),
        LYSA_MANUAL_REVIEW: React.createElement(LysaManualReview, null),
        ONFIDO_CLEAR: React.createElement(Clear, null),
        LYSA_MANUAL_REVIEW_CLEAR: React.createElement(Clear, null),
        ONFIDO_CONSIDER: React.createElement(OnfidoConsider, { idStatus: idStatus }),
        LYSA_CANCELED: React.createElement(OnfidoCanceled, null),
        ONFIDO_FAILED_STARTED: React.createElement(OnfidoFailedStarted, null),
        ONFIDO_FAILED_USER_ERROR: React.createElement(OnfidoFailedUserError, null),
        LYSA_MANUAL_REVIEW_REJECTED: (React.createElement(LysaManualReviewRejected, { idStatus: idStatus })),
        ONFIDO_DOCUMENT_FAILED_TYPE: (React.createElement(OnfidoDocumentFailedType, { idStatus: idStatus })),
    };
    return status[idStatus.status];
};
